var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"container"},[_c('div',{staticClass:"content-box"},[_c('div',{staticClass:"center-box"},[_c('MarketIdea')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }